import React, { useEffect, useState } from "react";
import styles from "./styles/ChatWithDesigner.module.css";
import ChatBox, { MessageCodeView } from "./ChatBox";
import classNames from "classnames";
import { useAtom, useAtomValue } from "jotai";
import {
    agentAtom,
    canvasAtom,
    currentActionAtom,
    messageListAtom,
} from "./atoms";
import { useSocket } from "./socket/socket";
import SocketManager from "./socket/SocketManager";
import log from "cslog";
import DesignCanvas from "./DesignCanvas";
import DesignCanvasList from "./DesignCanvasList";
import { Button, Drawer } from "antd";
import { CloseOutlined } from "@ant-design/icons";

function ChatWithDesigner({ me, isMobile }) {
    const [message_list, setMessageList] = useAtom(messageListAtom);
    // const [show_canvas, setShowCanvas] = useState(false);
    const [canvas, setCanvas] = useAtom(canvasAtom);
    const current_action = useAtomValue(currentActionAtom);
    const [agent, setAgent] = useAtom(agentAtom);

    const [open_cust, setOpenCust] = useState(true);

    // log.d(message_list, "Message List Now")
    log.d(me, "me in ChatWithDesigner");

    const show_canvas = canvas?.show;

    useEffect(() => {
        if (current_action) {
            switch (current_action.id) {
                case "hide_canvas":
                    setCanvas({ ...canvas, show: false });
                    break;
                case "show_canvas":
                    setCanvas({ ...canvas, show: true });
                    break;
            }
        }
    }, [current_action]);

    return (
        <div
            // className={styles.wrapper}
            className={classNames({
                [styles.wrapper]: true,
                [styles.show_canvas]: show_canvas,
            })}
        >
            {/* <div style={{
                flex: show_canvas ? 1 : 0
            }} className={classNames(styles.canvas,
                // styles.pattern_1
            )}>
                <DesignCanvasList data={canvas?.data} me={me} />
            </div> */}

            {/* <div style={{
                flex: show_canvas ? 1 : 0
            }} className={classNames(styles.canvas,
                // styles.pattern_1
            )}> */}

            {/* <DesignCanvasList data={canvas?.data} me={me} /> */}
            {/* </div> */}

            <CanvasDisplayWrapper
                isMobile={isMobile}
                open={show_canvas}
                setOpen={() => {
                    setCanvas({ ...canvas, show: !show_canvas });
                }}
            >
                {/* <MessageCodeView data={{ language: "json", code: canvas }} /> */}
                <DesignCanvasList
                    key={canvas?.data}
                    data={canvas?.data}
                    // data={prepareForCanvas(canvas?.data)}
                    me={me}
                    isMobile={isMobile}
                    closeBtn={
                        <Button
                            icon={<CloseOutlined />}
                            onClick={() =>
                                setCanvas({ ...canvas, show: false })
                            }
                        ></Button>
                    }
                    close_left={false}
                    open_cust={open_cust}
                    setOpenCust={setOpenCust}
                    history_id={canvas?.data?.data?.history_id}
                />
            </CanvasDisplayWrapper>

            <div className={styles.chat_box_wrapper}>
                <ChatBox
                    message_list={message_list}
                    wrapper_style={{
                        padding: 0,
                    }}
                    agent={agent}
                    setAgent={setAgent}
                />
            </div>

            {/* <div style={{
                width: "100%",
                height: "100%",
                outline: "1px dotted green"
            }}>Hello</div> */}

            <SocketManager
                me={me}
                onMessageReceived={(new_message) => {
                    log.d(new_message, "PROCESSED: Message Received");
                    setMessageList((old_list) => [...old_list, new_message]);
                }}
            />
        </div>
    );
}

function CanvasDisplayWrapper({ isMobile, children, open, setOpen }) {
    // const [open, setOpen] = useState(true);

    if (isMobile) {
        return (
            <Drawer
                // title={
                //     <div className={styles.drawer_title_wrapper}>
                //         {/* Title */}
                //         {/* <span className={styles.drawer_close_btn} onClick={() => setOpen(false)}>X</span> */}
                //         <div
                //             onClick={() => setOpen(false)}
                //             className={styles.drawer_close_btn_wrapper}
                //         >
                //             <Button icon={<CloseOutlined />}></Button>
                //         </div>
                //     </div>
                // }
                placement="bottom"
                closable={false}
                onClose={() => setOpen(false)}
                open={open}
                key="qureal_preview_drawer"
                height="90%"
                closeIcon={true}
                style={{
                    padding: 0,
                }}
                styles={{
                    body: {
                        padding: 5,
                        width: "100%",
                        // height: "30vh",
                        outline: "1px dotted red",
                    },
                }}
            >
                {children}
            </Drawer>
        );
    } else {
        return (
            <div
                style={{
                    flex: open ? 1 : 0,
                }}
                className={classNames(
                    styles.canvas
                    // styles.pattern_1
                )}
            >
                {children}
            </div>
        );
    }
}

export default ChatWithDesigner;

export function prepareForCanvas(canvas_data) {
    const key = Object.keys(canvas_data)[0];
    const value = canvas_data[key];
    // const prefill= value?.prefill.....
    return {
        type: key,
        data: value,
    };
}
